import { render, staticRenderFns } from "./NewTabOverview.vue?vue&type=template&id=82a0acea&"
import script from "./NewTabOverview.vue?vue&type=script&lang=js&"
export * from "./NewTabOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports